import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";

import CreatePeriodeView from "./CreatePeriode/View";
import CreateCP3KView from "./CreateCP3K/View";
import UploadSKView from "./UploadSK/View";
import DetailCP3KView from "./DetailCP3K/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _create = queryParams.get("create");
  const _create_cp3k = queryParams.get("create_cp3k");
  const _detail = queryParams.get("detail");
  const _delete = queryParams.get("delete");
  const _approve = queryParams.get("approve");
  const _print = queryParams.get("print");
  const _update = queryParams.get("update");
  const _upload_sk = queryParams.get("upload_sk");

  const _uuid = queryParams.get("uuid");

  if (_create != null) {
    return accessRole("create") ? <CreatePeriodeView /> : <ErrorAccess />;
  } else if (_detail != null) {
    return accessRole("read") ? <DetailCP3KView /> : <ErrorAccess />;
  } else if (_update != null) {
    return accessRole("update") ? null : <ErrorAccess />;
  } else if (_delete != null) {
    return null;
  } else if (_approve != null) {
    return accessRole("approve") ? null : <ErrorAccess />;
  } else if (_create_cp3k != null) {
    return accessRole("create") ? <CreateCP3KView /> : <ErrorAccess />;
  } else if (_upload_sk != null) {
    return accessRole("approve") ? <UploadSKView /> : <ErrorAccess />;
  } else if (_print != null) {
    return null;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
